<template>
  <div class="">
    <el-table
      :data="tableData"
      v-loading="tableLoading"
      border
    >
    <!-- v-infinite-scroll="load" -->
      <el-table-column prop="userid" label="删除人名称" style="width: 10%">
      </el-table-column>

      <el-table-column
        prop="external_userid"
        label="被删除人名称"
        style="width: 20%"
      >
      </el-table-column>
      <el-table-column prop="type" label="事件" style="width: 20%">
      </el-table-column>
      <el-table-column prop="createtime" label="时间" style="width: 50%">
        <template slot-scope="scope">
          <div>{{ (scope.row.createtime * 1000) | formatDate }}</div>
        </template>
      </el-table-column>
    </el-table>
    <div class="paging">
        <pagination
          :total="total"
          :page.sync="listQuery.page"
          :limit.sync="listQuery.limit"
          :page-sizes="[10,20,50,100]"
          :auto-scroll="false"
          @pagination="userTable"
        />
      </div>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
export default {
  name: "dele",
  data() {
    return {
      tableData: [],
      tooken: [],
      yeshu: 1,
      total: 0,
      listQuery: {
        page: 1,
        limit: 20,
      },
      tableLoading: true
    };
  },
  mounted() {
    if (window.localStorage.getItem("storuser")) {
      let userinfo = JSON.parse(window.localStorage.getItem("storuser"));
      // // console.log(userinfo);
      this.tooken = userinfo;
    }
    this.userTable();
  },
  filters: {
    formatDate: function (value) {
      let date = new Date(value);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
    },
  },
  methods: {
    userTable() {
      this.yeshu = 1;
      this.axios
        .post(
          "/home/keyword/deleteEvent",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            page: this.listQuery.page,
            number_page:this.listQuery.limit,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.tableLoading = false;
          this.tableData = res.data.data;
          this.total = res.data.count
        })
        .catch(function (err) {});
    },
    // load() {
    //   this.yeshu += 1;
    //   this.axios
    //     .post(
    //       "/home/keyword/deleteEvent",
    //       qs.stringify({
    //         usertoken: this.tooken.usertoken,
    //         account_id: this.tooken.account_id,
    //         phone: this.tooken.phone,
    //         page: this.yeshu,
    //         number_page:this.listQuery.limit,
    //       }),
    //       { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
    //     )
    //     .then((res) => {
    //       if (res.data.msg == "登录超时") {
    //         this.$router.push("/register");
    //       }
    //       res.data.data.forEach((item) => {
    //         this.tableData.push(item);
    //       });
    //     })
    //     .catch(function (err) {});
    // },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "success-row";
    },
  },
};
</script>
<style lang="scss" scoped>

.hello {
  width: 100%;
  height: 100%;
  padding: 2.0rem;
  overflow: hidden;
  overflow-y: auto;
}
nav {
  width: 100%;
}
.shij {
  display: inline-block;
  margin-right: 4.0rem;
}
</style>
